/**
 * Sanitizes a search string for use in search queries by escaping special characters
 */
export const sanitizeSearchString = (searchString: string): string => {
  if (!searchString) {
    return ''
  }

  // Escape OpenSearch special characters that could be used for query injection
  // Reference: https://docs.opensearch.org/latest/query-dsl/full-text/query-string/
  return (
    searchString
      // Replace single character special characters
      .replace(/[+\-=&|!(){}[\]^"~*?:\\/]/g, '\\$&') // Escape special characters
      // replace ||
      .replace(/\|\|/g, '\\||')
      // replace &&
      .replace(/&&/g, '\\&&')
      // replace AND
      .replace(/AND/g, '\\A\\N\\D')
      // replace OR
      .replace(/OR/g, '\\O\\R')
      // replace NOT
      .replace(/NOT/g, '\\N\\O\\T')
      .trim()
  )
}
